export const GENERATE_LINKEDINAD_REQUEST = 'GENERATE_LINKEDINAD_REQUEST'
export const GENERATE_LINKEDINAD_SUCCESS = 'GENERATE_LINKEDINAD_SUCCESS'
export const GENERATE_LINKEDINAD_FAIL = 'GENERATE_LINKEDINAD_FAIL'
export const GENERATE_LINKEDINAD_RESET = 'GENERATE_LINKEDINAD_RESET'

export const GENERATE_TAGLINE_REQUEST = 'GENERATE_TAGLINE_REQUEST'
export const GENERATE_TAGLINE_SUCCESS = 'GENERATE_TAGLINE_SUCCESS'
export const GENERATE_TAGLINE_FAIL = 'GENERATE_TAGLINE_FAIL'
export const GENERATE_TAGLINE_RESET = 'GENERATE_TAGLINE_RESET'

export const GENERATE_GOOGLEAD_REQUEST = 'GENERATE_GOOGLEAD_REQUEST'
export const GENERATE_GOOGLEAD_SUCCESS = 'GENERATE_GOOGLEAD_SUCCESS'
export const GENERATE_GOOGLEAD_FAIL = 'GENERATE_GOOGLEAD_FAIL'
export const GENERATE_GOOGLEAD_RESET = 'GENERATE_GOOGLEAD_RESET'

export const GENERATE_AMAZONDESC_REQUEST = 'GENERATE_AMAZONDESC_REQUEST'
export const GENERATE_AMAZONDESC_SUCCESS = 'GENERATE_AMAZONDESC_SUCCESS'
export const GENERATE_AMAZONDESC_FAIL = 'GENERATE_AMAZONDESC_FAIL'
export const GENERATE_AMAZONDESC_RESET = 'GENERATE_AMAZONDESC_RESET'

export const GENERATE_BLOGOUTLINE_REQUEST = 'GENERATE_BLOGOUTLINE_REQUEST'
export const GENERATE_BLOGOUTLINE_SUCCESS = 'GENERATE_BLOGOUTLINE_SUCCESS'
export const GENERATE_BLOGOUTLINE_FAIL = 'GENERATE_OUTLINE_FAIL'
export const GENERATE_BLOGOUTLINE_RESET = 'GENERATE_BLOGOUTLINE_FAIL'


export const GENERATE_BLOGIDEAS_REQUEST = 'GENERATE_BLOGIDEAS_REQUEST'
export const GENERATE_BLOGIDEAS_SUCCESS = 'GENERATE_BLOGIDEAS_SUCCESS'
export const GENERATE_BLOGIDEAS_FAIL = 'GENERATE_BLOGIDEAS_FAIL'
export const GENERATE_BLOGIDEAS_RESET = 'GENERATE_BLOGIDEAS_RESET'

export const GENERATE_BLOGQUOTE_REQUEST = 'GENERATE_BLOGQUOTE_REQUEST'
export const GENERATE_BLOGQUOTE_SUCCESS = 'GENERATE_BLOGQUOTE_SUCCESS'
export const GENERATE_BLOGQUOTE_FAIL = 'GENERATE_BLOGQUOTE_FAIL'
export const GENERATE_BLOGQUOTE_RESET = 'GENERATE_BLOGQUOTE_RESET'

export const GENERATE_BLOGINTRO_REQUEST = 'GENERATE_BLOGINTRO_REQUEST'
export const GENERATE_BLOGINTRO_SUCCESS = 'GENERATE_BLOGINTRO_SUCCESS'
export const GENERATE_BLOGINTRO_FAIL = 'GENERATE_BLOGINTRO_FAIL'
export const GENERATE_BLOGINTRO_RESET = 'GENERATE_BLOGINTRO_RESET'

export const GENERATE_DISPLAYADS_REQUEST = 'GENERATE_DISPLAYADS_REQUEST'
export const GENERATE_DISPLAYADS_SUCCESS = 'GENERATE_DISPLAYADS_SUCCESS'
export const GENERATE_DISPLAYADS_FAIL = 'GENERATE_DISPLAYADS_FAIL'
export const GENERATE_DISPLAYADS_RESET = 'GENERATE_DISPLAYADS_RESET'

export const GENERATE_FAQ_REQUEST = 'GENERATE_FAQ_REQUEST'
export const GENERATE_FAQ_SUCCESS = 'GENERATE_FAQ_SUCCESS'
export const GENERATE_FAQ_FAIL = 'GENERATE_FAQ_FAIL'
export const GENERATE_FAQ_RESET = 'GENERATE_FAQ_RESET'

export const GENERATE_PAINAGITATE_REQUEST = 'GENERATE_PAINAGITATE_REQUEST'
export const GENERATE_PAINAGITATE_SUCCESS = 'GENERATE_PAINAGITATE_SUCCESS'
export const GENERATE_PAINAGITATE_FAIL = 'GENERATE_PAINAGITATE_FAIL'
export const GENERATE_PAINAGITATE_RESET = 'GENERATE_PAINAGITATE_RESET'

export const GENERATE_FACEBOOKAD_REQUEST = 'GENERATE_FACEBOOKAD_REQUEST'
export const GENERATE_FACEBOOKAD_SUCCESS = 'GENERATE_FACEBOOKAD_SUCCESS'
export const GENERATE_FACEBOOKAD_FAIL = 'GENERATE_FACEBOOKAD_FAIL'
export const GENERATE_FACEBOOKAD_RESET = 'GENERATE_FACEBOOKAD_RESET'